'use strict'

import Hashids from 'hashids';
import { createSelector } from 'reselect';

import { getUrlParams } from '../app/selectors';

export const getMap = ({ locations }) => locations.byId;
export const getLocationId = (_, { locationId }) => locationId;

export const getPageLocation = createSelector(
	[ getUrlParams, getMap ],
	({ hashLocationId }, locations) => {

		const hashids = new Hashids();
		const locationId = hashids.decodeHex(hashLocationId);

		return locations[ locationId ];
	}
);

export const getLocation = createSelector(
	[ getMap, getLocationId ],
	(locations, locationId) => locations[ locationId ]
);
